import { useUpdateCreditCardApplicationQuery } from "@lending/hooks/queries/CreditCardApplication/useUpdateCreditCardApplicationQuery";
import { usePatchPersonalLoanApplicationQuery } from "@lending/hooks/queries/PersonalLoanApplication/usePatchPersonalLoanApplicationQuery";
import { usePatchVehicleLoanApplicationQuery } from "@lending/hooks/queries/VehicleLoanApplication/usePatchVehicleLoanApplicationQuery";
import type { ProductType } from "@lending/navigation";
import type { MlaStatusEnum } from "@lending/types";

function useSaveMlaStatus() {
  const mutations = {
    "personal-loan": usePatchPersonalLoanApplicationQuery(),
    "auto-loan": usePatchVehicleLoanApplicationQuery(),
    "credit-card": useUpdateCreditCardApplicationQuery(),
  };

  return (productType: ProductType, applicationUuid: string, mlaStatus: MlaStatusEnum) =>
    mutations[productType].mutateAsync({
      params: { path: { uuid: applicationUuid } },
      body: { mla_status: mlaStatus },
    });
}

export { useSaveMlaStatus };
